<template>
  <div>
    <TheNavigationPanel/>
    <router-view></router-view>
  </div>
</template>

<script>
import TheNavigationPanel from '../components/TheNavigationPanel';

export default {
  name: 'mainlayout',
  components: {
    TheNavigationPanel,
  },
  data: () => ({
    
  }),
   created: function () {
      
      
    }
   
};
</script>
<style  scoped>
 
</style>